angular.module('tf.controllers')
    .value('duScrollDuration', 500)
    .value('duScrollOffset', 110)
    .controller('StatisticsController', ['$scope','User','HttpService', 'StatisticsService','$timeout','ProjectService','$q','$stateParams','properties',
        function ($scope, User, HttpService, StatisticsService, $timeout, ProjectService, $q, $stateParams, properties) {

            //var fid = 'Qzpccm9vdA==';
            //var projectId = 'Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMS50ZnA=';
            //var uid = "56cddab1b9cdab58be0c6e5a";

            //$scope.pie = 'pie';
            //$scope.line = 'line';
            //$scope.projectUsersChartType = 'pie';
            //$scope.projectTemplatesChartType = 'pie';
            //$scope.projectUsageChartType = 'line';
            //
            //$scope.projectUsersChartUnit = 'day';
            //$scope.projectTemplatesChartUnit = 'day';
            //$scope.projectUsageChartUnit = 'day';


            $scope.properties = {
                name    : properties.name || 'ROOT',
                type    : $stateParams.type || 'produce',
                fid     : properties.fid,// || 'Qzpccm9vdA==',
                pid     : properties.path,
                path    : properties.path,// || 'Qzpccm9vdA==',
                fromDate: $stateParams.fromDate,
                toDate  : $stateParams.toDate,
                unit    : $stateParams.unit,
                isProject: properties.type == 1,
                project : $stateParams.project,
                test    : $stateParams.test
            };

            var options = {
                from_date: $stateParams.fromDate,
                to_date  : $stateParams.toDate,
                unit    : $stateParams.unit,
                test    : $stateParams.test,
                project : $stateParams.project
            };

            $scope.cards = {};

            $scope.userChartOptions = {type : 'pie'};
            $scope.popularChartOptions = {type : 'pie'};
            $scope.usageChartOptions = {type : 'line'};
            $scope.farmerChartOptions = {type : 'line'};


            $scope.activeProjectsChartOptions = {type:'line', title:'Active Projects', test : $scope.properties.test};
            $scope.chartOptions = {
                activeProjects : _.extend({}, !options.project?
                    {type:'line', title:'Active Projects', test : $scope.properties.test, project : $scope.properties.project, clickKey:"project"} :
                    {type:'line', title:'Active Templates', test : $scope.properties.test, project : $scope.properties.project}),
                activeTemplates : {type:'line', title:'Active Templates', test : $scope.properties.test},
                totalUsers : {type:'pie', title:'Total Users', hideTypes:true, test : $scope.properties.test, project : $scope.properties.project},
                usersActivity : {type:'line', title:'Users Activity', hideTypes:false, test : $scope.properties.test, project : $scope.properties.project},
                farmerLoad : {type:'line', hideTypes:true, title:'Farmer Load', test : $scope.properties.test, project : $scope.properties.project}
            };


            $scope.statHeader = function(){
              return $scope.properties.isProject ? $scope.properties.project:"STAT";
            };



            $scope.getFolderUsers = function (fid, path, options){
                return StatisticsService.folderUsers(fid, path, options);
            };
            $scope.getProjectUsers = function(fid, id, options){
                return StatisticsService.projectUsers(fid, id, options);
            };
            $scope.getFolderProjects = function(fid, path, options){
                return StatisticsService.folderUsage(fid, path, options);
            };
            $scope.getProjectTemplates = function (fid, id, options) {
                return StatisticsService.projectUsage(fid, id, options);
            };
            $scope.getProjectUsage = function (fid, id, options) {
                return StatisticsService.projectUsage(fid, id, options);
            };
            $scope.getFarmerLoad = function(fid, options){
                return StatisticsService.farmerLoad(fid, options);
            };

            $scope.plan = function() {
                StatisticsService.plan().then(function (data) {

                    var unlimited = 10;
                    $scope.submitsUsed = ['Productions', data[0][1]];
                    $scope.submitsTotal = data[0][0] > 0? data[0][0] : unlimited;

                    $scope.previewsUsed = ['Previews', data[1][1]];
                    $scope.previewsTotal = data[1][0] > 0? data[1][0] : unlimited;

                    $scope.farmersUsed = ['Farmers', data[2][1]];
                    $scope.farmersTotal = data[2][0] > 0? data[2][0] : unlimited;

                    $scope.usersUsed = ['Users', data[3][1]];
                    $scope.usersTotal = data[3][0] > 0? data[3][0] : unlimited;

                });
            };




            if($scope.properties.isProject){
                //StatisticsService.cards.projectProductions($scope.properties.fid, $scope.properties.pid, options).then(function(data){
                //    console.log(data);
                //    $scope.cards.productions = {
                //        total : data.total,
                //        monthly : data.monthly,
                //        daily : data.daily
                //    };
                //});
            } else {
                StatisticsService.cards.productions($scope.properties.fid, $scope.properties.path, options).then(function(data){
                    //console.log(data);
                    $scope.cards.productions = {
                        total : data.total,
                        monthly : data.monthly,
                        daily : data.daily
                    };
                });
            }
            if($scope.properties.isProject){

            } else {
                StatisticsService.cards.users($scope.properties.fid, $scope.properties.path, options).then(function (data) {
                    //console.log(data);
                    $scope.cards.users = {
                        total: data.total,
                        monthly: data.monthly,
                        daily: data.daily
                    };
                });
            }
            //StatisticsService.cards.users(properties.fid, properties.path, options);


            //HttpService.post('stat/random', {pid : projectId, num : 1000});
            //HttpService.post('stat/migrate', {});



            //$scope.selected = {};
            //if(ProjectService.project){
            //    $scope.selected = {project : ProjectService.project};
            //}

            //$scope.loadStats = function () {
            //
            //    //$scope.getProjects();
            //  //  $scope.projectUsers($scope.selected.project.fid,$scope.selected.project.id);
            //  //  $scope.projectTemplates($scope.selected.project.fid,$scope.selected.project.id);
            //  //  $scope.projectUsage($scope.selected.project.fid,$scope.selected.project.id);
            //
            //    $scope.plan();
            //    $scope.farmerLoad($scope.selected.project.fid);
            //};

            //$scope.projectUsers = function(fid, projectId){
            //
            //    StatisticsService.projectUsers(fid, projectId).then(function (data) {
            //        $scope.projectUsersData = data;
            //    });
            //};
            //
            //$scope.projectTemplates = function(fid, projectId) {
            //    StatisticsService.projectTemplates(fid, projectId).then(function (data) {
            //        $scope.projectTemplatesData = data;
            //    });
            //};

            //$scope.getProjects = function(){
            //    var defer = $q.defer();
            //    StatisticsService.projects().then(function (data) {
            //        $scope.projects = _.pluck(data, 'project');
            //        if(!$scope.selected.project){
            //            $scope.selected.project =  $scope.projects[2];
            //        }
            //        defer.resolve($scope.projects);
            //    });
            //    return defer.promise;
            //};

            //$scope.farmerLoad = function(fid){
            //    StatisticsService.farmerLoad(fid).then(function (data) {
            //        $scope.farmerLoadData = data;
            //    });
            //};

            //$scope.projectUsage = function(fid, projectId){
            //    StatisticsService.projectUsage(fid, projectId).then(function (data) {
            //        $scope.projectUsageData = data;
            //    });
            //};

            //$scope.userProjects = function(){
            //    StatisticsService.userProjects(uid).then(function (data) {
            //        //console.log("User Projects: ", data);
            //    });
            //};

            //$scope.getProjects().then(function(projects){
            //  //  $scope.projectUsers($scope.selected.project.fid,$scope.selected.project.id);
            //  //  $scope.projectTemplates($scope.selected.project.fid,$scope.selected.project.id);
            //  //  $scope.projectUsage($scope.selected.project.fid,$scope.selected.project.id);
            //    $scope.plan();
            //    $scope.farmerLoad($scope.selected.project.fid);
            //    $scope.userProjects();
            //});

            var generateRandomDates = function () {
                HttpService.get('stat/dates');
            };
            
        }]);